import { render, staticRenderFns } from "./delay.vue?vue&type=template&id=a2e4f168&scoped=true&lang=pug&"
import script from "./delay.vue?vue&type=script&lang=js&"
export * from "./delay.vue?vue&type=script&lang=js&"
import style0 from "./delay.vue?vue&type=style&index=0&id=a2e4f168&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e4f168",
  null
  
)

export default component.exports